import { useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@chakra-ui/react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import WorkFlowFormModal from "../WorkFlowFormModal/WorkFlowFormModal";
import { fieldsArray, workFlowInitialValues } from "./utils/constant";
import { updateWorkFlowInitialValues } from "./utils/function";
import { replaceLabelValueObjects } from "utils/functions/function";

const AddForm = ({ handleGetData }: any) => {
  const { toastNotify, getUsersWorkFlows } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const updatedValues = updateWorkFlowInitialValues(
    workFlowInitialValues
  );

  const submitForm = async (values: any, resetForm: any) => {
    try {
      setLoading(true);
      if (values) {
        const payload = {
          ...replaceLabelValueObjects(values),
          processName: values.processName?.value || (Array.isArray(values.processName) ? values.processName[0] : values.processName),
          processType: values.processType?.value || (Array.isArray(values.processType) ? values.processType[0] : values.processType),
          regions: values.regions?.value || (Array.isArray(values.regions) ? values.regions[0] : values.regions),
        };
        const response: any = await appRequest("workflow", "create", payload);
        if (response.status === "success") {
          toastNotify({
            title: `Workflow Created successfully`,
            message: response.message || "Something went wrong.",
            type: "success"
          });
          handleGetData();
          getUsersWorkFlows();
          resetForm();
          handleCloseModal();
        } else {
          toastNotify({
            title: `Error getting the workflow.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      }
    } catch (err: any) {
      console.log(err)
      toastNotify({
        title: `Error getting the workflow.`,
        message: err.message || "Something went wrong.",
        type: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  return (
    <>
      <div>
        <Button
          color="white"
          w={{ base: "5rem", lg: "8rem" }}
          _hover={{
            bg: "teal.400",
          }}
          bg="teal.300"
          fontSize={{ base: "xs", lg: "sm" }}
          onClick={() => handleOpenModal()}
        >
          Add Workflow
        </Button>
      </div>
      <WorkFlowFormModal
        type="create"
        isOpen={isOpen}
        onClose={handleCloseModal}
        initialValues={{ ...updatedValues, identifier: uuidv4() }}
        loading={loading}
        submitForm={submitForm}
        showError={showError}
        setShowError={setShowError}
      />
    </>
  );
};

export default AddForm;
